import type {
  AudienceType,
  BlogCategory,
  DurationBand,
  InquiryPriority,
  InquiryStatus,
  InquiryType,
  LearnerLevel,
  LearningMode,
  ProgramType,
  ResourceAccess,
  ResourceType,
  SkillType,
} from './enums';

/** Human-readable labels for display. Single source for both site and admin. */

export const SKILL_LABELS: Record<SkillType, string> = {
  SPEAKING: 'Speaking',
  LISTENING: 'Listening',
  GRAMMAR: 'Grammar',
  VOCABULARY: 'Vocabulary',
  READING: 'Reading',
  WRITING: 'Writing',
  PRONUNCIATION: 'Pronunciation',
};

export const LEVEL_LABELS: Record<LearnerLevel, string> = {
  BEGINNER: 'Beginner',
  ELEMENTARY: 'Elementary',
  INTERMEDIATE: 'Intermediate',
  UPPER_INTERMEDIATE: 'Upper intermediate',
  ADVANCED: 'Advanced',
};

export const RESOURCE_TYPE_LABELS: Record<ResourceType, string> = {
  ACTIVITY: 'Activity',
  ARTICLE: 'Article',
  VIDEO: 'Video',
  AUDIO: 'Audio',
  WORKSHEET: 'Worksheet',
  SPEAKING_DRILL: 'Speaking drill',
  QUIZ: 'Quiz',
};

export const RESOURCE_ACCESS_LABELS: Record<ResourceAccess, string> = {
  FREE: 'Free',
  ACCOUNT: 'Account required',
};

export const AUDIENCE_LABELS: Record<AudienceType, string> = {
  ADULTS: 'Adults',
  STUDENTS: 'Students',
  CHILDREN: 'Children',
  PROFESSIONALS: 'Professionals',
};

export const DURATION_BAND_LABELS: Record<DurationBand, string> = {
  MIN_0_5: '0–5 minutes',
  MIN_5_10: '5–10 minutes',
  MIN_10_20: '10–20 minutes',
  MIN_20_PLUS: '20+ minutes',
};

export const PROGRAM_TYPE_LABELS: Record<ProgramType, string> = {
  GROUP: 'Small group',
  PRIVATE: 'Private coaching',
  CORPORATE: 'Corporate training',
  CHILDREN: 'Young learners',
  ONLINE: 'Online',
  BOOTCAMP: 'Bootcamp',
};

export const LEARNING_MODE_LABELS: Record<LearningMode, string> = {
  IN_PERSON: 'In person (Kigali)',
  ONLINE: 'Online',
  HYBRID: 'Hybrid',
};

export const INQUIRY_TYPE_LABELS: Record<InquiryType, string> = {
  GENERAL: 'General contact',
  CONSULTATION: 'Consultation booking',
  PLACEMENT_TEST: 'Placement test',
  CORPORATE: 'Corporate training',
};

export const INQUIRY_STATUS_LABELS: Record<InquiryStatus, string> = {
  NEW: 'New',
  CONTACTED: 'Contacted',
  IN_PROGRESS: 'In progress',
  CONVERTED: 'Converted',
  CLOSED: 'Closed',
};

export const INQUIRY_PRIORITY_LABELS: Record<InquiryPriority, string> = {
  LOW: 'Low',
  NORMAL: 'Normal',
  HIGH: 'High',
};

export const BLOG_CATEGORY_LABELS: Record<BlogCategory, string> = {
  SPEAKING_CONFIDENCE: 'Speaking confidence',
  ENGLISH_FOR_WORK: 'English for work',
  ENGLISH_FOR_RWANDA: 'English for Rwanda',
  LEARNING_TIPS: 'Learning tips',
  BUSINESS_ENGLISH: 'Business English',
  CHILDREN_LEARNING: 'Children learning',
  TECHNOLOGY_IN_LEARNING: 'Technology in learning',
};
